import { request } from '@koi-design/vix-tools';
import { packApi } from '@/libs/tools';

export const toggleAbleFlowApi = data => {
  return packApi({
    url: `/api/api-chatflow/intention/set_active/`,
    method: 'post',
    data
  });
};

export function getIndentSettingApi(data) {
  return request({
    url: `/api/api-robot/robot/robots/get_intention_config/`,
    method: 'get',
    data
  });
}

export function setIndentSettingApi(data) {
  return packApi({
    url: '/api/api-robot/robot/robots/save_intention_config/',
    method: 'post',
    data
  });
}

export function getIntentionOptsApi(data) {
  return request({
    url: `/api/api-chatflow/intention/`,
    method: 'get',
    data
  });
}

export function createIndentApi(data, type = 'boolean') {
  return packApi(
    {
      url: '/api/api-chatflow/intention/',
      method: 'post',
      data
    },
    type
  );
}

export const updateIndentApi = (data, id, type = 'object') => {
  return packApi(
    {
      url: `/api/api-chatflow/intention/${id}/`,
      method: 'put',
      data,
      removeEmptyFields: false
    },
    type
  );
};

export function delIndentApi(id, data) {
  return packApi({
    url: `/api/api-chatflow/intention/${id}/`,
    method: 'delete',
    data
  });
}

export function getJumpIntentApi(data) {
  return request({
    url: '/api/api-chatflow/intention/get_intention/',
    method: 'get',
    data
  });
}

export function getFlowNameApi(data) {
  return request({
    url: '/api/api-chatflow/chatflow/get_flow_name/',
    method: 'get',
    data
  });
}

// export function createEntityApi(data) {
//   return packApi({
//     url: '/api/api-chatflow/entity/',
//     method: 'post',
//     data
//   });
// }

// export function editEntityApi(data, id) {
//   return packApi({
//     url: `/api/api-chatflow/entity/${id}/`,
//     method: 'put',
//     data
//   });
// }

// export function getEntityListApi(data) {
//   return packApi(
//     {
//       url: `/api/api-chatflow/entity/`,
//       method: 'get',
//       data
//     },
//     'json'
//   );
// }

// export function deleteEntityApi(id, data) {
//   return packApi({
//     url: `/api/api-chatflow/entity/${id}/`,
//     method: 'delete',
//     data
//   });
// }

export function createVarApi(data) {
  return packApi({
    url: '/api/v1/workflow-agent/variable/',
    method: 'post',
    data
  });
}

export function editVarApi(data, id) {
  return packApi({
    url: `/api/v1/workflow-agent/variable/${id}/`,
    method: 'put',
    data
  });
}

export function getVarListApi(data) {
  return request(
    {
      url: `/api/v1/workflow-agent/variable/`,
      method: 'get',
      data
    },
    'json'
  );
}

export function deleteVarApi(id, data) {
  return packApi({
    url: `/api/v1/workflow-agent/variable/${id}/`,
    method: 'delete',
    data
  });
}

export function getFlowApi(data) {
  return request({
    url: `/api/api-chatflow/chatflow/5/`,
    method: 'get',
    data
  });
}

export function publishFlowApi(data) {
  return packApi({
    url: '/api/api-chatflow/release/',
    method: 'post',
    data
  });
}

export function getIndentApi(id) {
  return request({
    url: `/api/api-chatflow/intention/${id}/`,
    method: 'get'
  });
}

export function getTaskFlowDataApi(data) {
  return request(
    {
      url: '/api/v1/workflow-agent/agents/detail',
      method: 'get',
      data
    },
    'json'
  );
}

export function createTaskFlowAgentApi(data) {
  return request({
    url: '/api/v1/workflow-agent/agents',
    method: 'post',
    data
  });
}

export function updateTaskFlowApi(data) {
  return packApi(
    {
      url: `/api/v1/workflow-agent/agents/draft`,
      method: 'post',
      data
    },
    'json'
  );
}

export function getDefaultModelApi(data) {
  return request({
    url: '/api/api-robot/robot/robots/default_model/',
    method: 'get',
    data
  });
}

export function setVariableApi(data) {
  return request({
    url: '/api/api-chatflow/chatflow/get_flow_entity_variable/',
    method: 'get',
    data
  });
}

export function getIsDevelopApi() {
  return request({
    url: '/api/api-chatflow/chatflow/get_develop_user/',
    method: 'get'
  });
}

export function getLineMapApi(data) {
  return request({
    url: '/api/v1/workflow-agent/workflow_node/',
    method: 'get',
    data
  });
}

export function getDependentVarApi(data) {
  return request({
    url: '/api/v1/workflow-agent/workflow/get_dependent_variable/',
    method: 'get',
    data
  });
}

export function getTaskFlowApiPreviewApi(data) {
  return request({
    url: '/api/v1/flow-server/workflow/llm_preview/',
    method: 'post',
    data
  });
}

export function copyRobotIndentApi(data) {
  return packApi({
    url: `/api/api-chatflow/intention/duplicate_intention/`,
    method: 'post',
    data
  });
}

export function shareToHomelandApi(data) {
  return packApi({
    url: `/api/api-chatflow/intention/share_to_homeland/`,
    method: 'post',
    data
  });
}

export function bindIndentApi(data) {
  return packApi({
    url: `/api/api-chatflow/intention/bind_intention/`,
    method: 'post',
    data
  });
}

export function unbindIndentApi(data) {
  return packApi({
    url: `/api/api-chatflow/intention/unbind_intention/`,
    method: 'post',
    data
  });
}
export function getHomelandRobotsApi(data) {
  return request({
    url: '/api/api-robot/robot/robots/get_homeland_robots/',
    method: 'post',
    data
  });
}

export function importChatflowApi(data) {
  return request({
    url: '/api/api-chatflow/chatflow/import_chatflow/',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 60000 * 10
  });
}

export function exportChatflowApi(data) {
  return request({
    url: '/api/api-chatflow/chatflow/export_chatflow/',
    method: 'post',
    responseType: 'blob',
    catchAll: true,
    data
  });
}

export function getFileListApi(data) {
  return packApi(
    {
      url: '/api/v1/workflow-agent/file_category/',
      method: 'get',
      data
    },
    'json'
  );
}

export function createFileApi(data) {
  return packApi({
    url: '/api/v1/workflow-agent/file_category/',
    method: 'post',
    data
  });
}

export function editFileApi(data, id) {
  return packApi({
    url: `/api/v1/workflow-agent/file_category/${id}/`,
    method: 'put',
    data
  });
}

export function deleteFileApi(id, params) {
  return packApi({
    url: `/api/v1/workflow-agent/file_category/${id}/`,
    method: 'delete',
    params
  });
}

export function getFileParseTypesApi(data) {
  return request({
    url: '/api/v1/workflow-agent/file_category/get_file_format/',
    method: 'get',
    params: data
  });
}

export function getFileFormatsApi() {
  return request({
    url: '/api/v1/workflow-agent/file_category/get_file_format/',
    method: 'get'
  });
}

export function uploadFileApi(data) {
  return request({
    url: '/api/api-chatflow/chatflow/upload_file/',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 60000 * 20 // 2 minutes timeout for file uploads
  });
}

export function uploadWorkflowFileMetaApi(data) {
  return request({
    url: '/api/v1/workflow-agent/workflow/file/upload/meta',
    method: 'post',
    data
  });
}

export function uploadWorkflowFileParsesMetaApi(data) {
  return request({
    url: '/api/v1/workflow-agent/workflow/file/parses/meta',
    method: 'post',
    data
  });
}

export function getFileContentApi(data) {
  return request({
    url: '/api/v1/workflow-agent/workflow/file/content',
    method: 'post',
    data
  });
}

export function deleteWorkflowFileMetaApi(data) {
  return request({
    url: '/api/v1/workflow-agent/workflow/file/delete',
    method: 'post',
    data
  });
}

export function getFolderTreeListPlusApi(data) {
  return request({
    url: '/api/api-knowledge/knowledge/knowledge_folder/get_folder_tree_list_plus/',
    method: 'get',
    data
  });
}

export function createFlowByNameApi(data) {
  return request({
    url: '/api/api-chatflow/chatflow/create_by_name/',
    method: 'post',
    data
  });
}

export function generateTaskFlowWebhookUrlApi(data) {
  return request({
    url: '/api/v1/workflow-agent/triggers/webhook-url',
    method: 'post',
    data
  });
}

export function testTaskFlowEmailConnectionApi(data) {
  return request({
    url: '/api/v1/workflow-agent/triggers/email/imap/test',
    method: 'post',
    data
  });
}

export function getEmailImapFieldsApi() {
  return request({
    url: '/api/v1/workflow-agent/triggers/email/imap/fields',
    method: 'get'
  });
}

export function uploadHotwordsApi(data) {
  return request({
    url: '/api/v1/workflow-agent/workflow/upload_hotwords/',
    method: 'post',
    data
  });
}

export function updateFlowNameApi(data) {
  return request({
    url: '/api/api-chatflow/chatflow/update_name/',
    method: 'post',
    data
  });
}

export function getHotwordsTemplateApi(data) {
  return request({
    url: '/api/api-chatflow/chatflow/hotwords_tmpl/',
    method: 'get',
    data,
    responseType: 'blob',
    catchAll: true
  });
}

export function downloadHotwordsApi(data) {
  return request({
    url: '/api/v1/workflow-agent/workflow/download_hotwords',
    method: 'get',
    data,
    responseType: 'blob',
    catchAll: true
  });
}
export function deleteTaskFlowAgentDraftApi(data) {
  return packApi({
    url: `/api/v1/workflow-agent/agents/delete`,
    method: 'post',
    data
  });
}

export function getRobotIntentionConfigApi(data) {
  return request({
    url: '/api/api-chatflow/intention/get_robot_intention_config/',
    method: 'get',
    data
  });
}

export function getPluginOutputsOptionsApi(data) {
  return request({
    url: '/api/api-knowledge/plugin/plugins/get_plugin_detail/',
    method: 'get',
    data
  });
}

export function getDatabaseDataApi(data) {
  return request({
    url: '/api/api-database/db/get_structure_dbs/',
    method: 'get',
    data
  });
}

export function startTaskFlowChatflowUrlUploadApi(data) {
  return request({
    url: '/api/v1/react-agent/chatflow/file_upload/url/',
    method: 'post',
    data
  });
}

export function getTaskFlowChatflowUrlUploadStatusApi(data) {
  return request({
    url: '/api/v1/react-agent/chatflow/file_upload/url/status/',
    method: 'get',
    params: data
  });
}

export function getDatabaseFieldsApi(data) {
  return request({
    url: '/api/api-database/detail-table/',
    method: 'get',
    data
  });
}

export function getNodeConfigApi(data) {
  return request({
    url: '/api/api-chatflow/chatflow/get_node_config/',
    method: 'get',
    data
  });
}

export function getTaskflowAgentInfoApi(data) {
  return request({
    url: '/api/v1/workflow-agent/agents/release/info',
    method: 'get',
    data
  });
}

export function getTaskflowAgentHistoryApi(data) {
  return request({
    url: '/api/v1/workflow-agent/agents/call-history/',
    method: 'get',
    data
  });
}

export function toggleTaskflowAgentHistoryPinApi(data) {
  return packApi({
    url: '/api/v1/workflow-agent/agents/call-history/pin/',
    method: 'post',
    data
  });
}

export function deleteTaskflowAgentHistoryApi(data) {
  return packApi({
    url: '/api/v1/workflow-agent/agents/call-history/delete',
    method: 'post',
    data
  });
}

export function modifyTaskflowAgentHistoryApi(data) {
  return packApi({
    url: '/api/v1/workflow-agent/agents/call-history/modify',
    method: 'post',
    data
  });
}

export function getTaskflowAgentReleaseRecordApi(data) {
  return request({
    url: '/api/v1/workflow-agent/agents/release/records',
    method: 'get',
    data
  });
}

export function restoreTaskflowAgentReleaseRecordApi(data) {
  return packApi({
    url: '/api/v1/workflow-agent/agents/release/restore/',
    method: 'post',
    data
  });
}

export function offlineTaskFlowAgentApi(data) {
  return packApi({
    url: '/api/v1/workflow-agent/agents/offline',
    method: 'post',
    data
  });
}

export function exportTaskFlowAgentApi(data) {
  return request({
    url: '/api/v1/workflow-agent/agents/export',
    method: 'get',
    data,
    responseType: 'blob',
    catchAll: true
  });
}

export function downloadTaskflowAgentHistoryApi(data) {
  return request({
    url: '/api/v1/workflow-agent/agents/call-history/export',
    method: 'get',
    data,
    responseType: 'blob',
    catchAll: true
  });
}

export function copyTaskFlowAgentToSpaceApi(data) {
  return request({
    url: '/api/v1/workflow-agent/agents/copy',
    method: 'post',
    data
  });
}


export const getTaskFlowAgentTracesHierarchyListApi = data => {
  return request({
    url: '/api/v1/workflow-agent/traces/hierarchy-list',
    method: 'get',
    params: data
  });
};

export const getTaskFlowAgentTracesSpanDetailApi = data => {
  return request({
    url: '/api/v1/workflow-agent/traces/span/detail',
    method: 'get',
    params: data
  });
};

export const getTaskFlowAgentCalltrendApi = data => {
  return request({
    url: '/api/v1/workflow-agent/statistics/calltrend',
    method: 'post',
    data
  });
};

export const getTaskFlowAgentSectionCallApi = data => {
  return request({
    url: '/api/v1/workflow-agent/statistics/sectioncall',
    method: 'post',
    data
  });
};

export const getTaskFlowAgentUserApi = data => {
  return request({
    url: '/api/v1/workflow-agent/agents/user',
    method: 'get',
    params: data
  });
};

export const getTaskFlowAgentPublishInfoApi = data => {
  return request({
    url: '/api/v1/workflow-agent/agents/start-config',
    method: 'get',
    params: data
  });
};

export const validateTaskFlowAgentPublishApi = data => {
  return request({
    url: '/api/v1/flow-server/workflow/publish/validate',
    method: 'post',
    data
  });
};

export function getMcpReleaseStateApi(data) {
  return request({
    url: '/api/v1/workflow-agent/agents/release/mcp/state',
    method: 'get',
    data
  });
}

export function getMcpReleaseJsonApi(data) {
  return request({
    url: '/api/v1/workflow-agent/agents/release/mcp/json',
    method: 'get',
    data
  });
}

export function revokeWorkflowAgentMcpReleaseApi(data) {
  return packApi(
    {
      url: '/api/v1/workflow-agent/agents/release/mcp/revoke',
      method: 'post',
      data
    },
    'boolean',
    true
  );
}
